<template>
  <el-tabs :tab-position="tabPosition" >
    <el-tab-pane label="Tag"><TagManage/></el-tab-pane>
    <el-tab-pane label="配置管理">配置管理</el-tab-pane>
    <el-tab-pane label="角色管理">角色管理</el-tab-pane>
    <el-tab-pane label="定时任务补偿">定时任务补偿</el-tab-pane>
  </el-tabs>
</template>


<script>
import { getBadgeList } from '../components/badge'
import TagManage from './Manage/TagManage.vue';
export default {
    components: {
        TagManage
    },
    data() {
      return {
        tabPosition: 'left'
      };
    },
    mounted() {
        this.initBadge()
    },
    methods: {

        initBadge() {
            let k = ['html', 'css', 'less', 'javascri', 'java', 'openlaye', 'vue', 'spring', 'springboot', 'springsecurity', 'nginx', 'cloudflare', 'redis', 'kafka', 'docker', 'echarts', 'e',]
            let nullable = getBadgeList(k)
            console.log(k)
            console.log(nullable)
            this.showBadgeList = nullable
        }
    }
};
</script>
